/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Micah_RobbinsInputs */

const en_testimonial_micah_robbins = /** @type {(inputs: Testimonial_Micah_RobbinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I love this app, it has everything you need to turn your favourite books into audiobooks. It's life changing. Now I can save so much time by multitasking and all thanks to you guys ! Keep going and I wish you all the luck !`)
};

const es_testimonial_micah_robbins = /** @type {(inputs: Testimonial_Micah_RobbinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me encanta esta app, tiene todo lo que necesitas para convertir tus libros favoritos en audiolibros. Te cambia la vida. Ahora puedo ahorrar mucho tiempo haciendo varias cosas a la vez, ¡y todo gracias a ustedes! ¡Sigan así y les deseo toda la suerte!`)
};

/**
* | output |
* | --- |
* | "I love this app, it has everything you need to turn your favourite books into audiobooks. It's life changing. Now I can save so much time by multitasking and..." |
*
* @param {Testimonial_Micah_RobbinsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_micah_robbins = /** @type {((inputs?: Testimonial_Micah_RobbinsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Micah_RobbinsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_micah_robbins(inputs)
	return en_testimonial_micah_robbins(inputs)
});